<template>
    <v-dialog v-model="dialog" @click:outside="hide" max-width="500">
        <v-card v-if="coach">
            <v-app-bar color="white" flat dense>
                <div class="app-title">
                    {{ $t('student.rate_coach') }}
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="hide">
                    <v-icon color="#707070">$close</v-icon>
                </v-btn>
            </v-app-bar>

            <v-divider/>

            <v-card-text v-if="rated" class="mt-3">
                <div class="subtext">
                    {{ $t('student.rate_coach_subtext', {name: coach.name}) }}
                </div>

                <div class="text-center my-3">
                    <v-rating
                        large
                        v-model="stars"
                        background-color="black"
                    />
                </div>

                <v-btn block color="primary" class="black--text normal-btn" depressed @click="ratingCoach"
                       :loading="loading">
                    {{ $t('common.confirm') }}
                </v-btn>
            </v-card-text>
            <v-card-text v-else class="mt-3 text-center">
                <v-icon size="50" color="secondary">mdi-check-circle-outline</v-icon>
                <div class="subtext mt-3">
                    {{ $t('student.already_rate_coach', {name: coach.name}) }}
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import {mapState, mapMutations} from 'vuex'
import {db} from "@/utils/Firebase";

export default {
    props: {
        coach: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            dialog: false,
            stars: 0,
            loading: false,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        coachId(vm = this) {
            return vm.$route.params.uid
        },
        rated(vm = this) {
            return vm.account?.studentSubscription?.rated || false
        }
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.stars = 0
        },
        async ratingCoach() {
            const vm = this
            vm.loading = true
            const starsAvg = vm.coach.rating ? vm.coach.rating.stars : 0
            let votesCount = vm.coach.rating ? vm.coach.rating.count : 0
            const starsSum = starsAvg * votesCount
            const starsGiven = vm.stars
            const totalStars = starsSum + starsGiven
            votesCount++
            const newStarsAvg = Math.round((totalStars / votesCount) * 100) / 100

            await db.collection('users').doc(vm.coachId).update({
                rating: {stars: newStarsAvg, count: votesCount}
            })

            await db.collection('users').doc(vm.currentUser.uid).update({
                'studentSubscription.rated': true
            })

            vm.$emit('success')
            vm.hide()
            vm.loading = false
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        }
    }
}

</script>

<style scoped>

.app-title {
    color: #707070;
    font-size: 20px;
    font-weight: bold;
}

.subtext {
    color: #707070;
    font-size: 17px;
}

</style>